export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de": {
        "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategorie"])},
        "amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anzahl"])},
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])},
        "smartphone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Handy"])},
        "pencil": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stift"])},
        "cup": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tasse"])}
      },
      "en": {
        "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Category"])},
        "amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Number of samples"])},
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])},
        "smartphone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Phone"])},
        "pencil": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pencil"])},
        "cup": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cup"])}
      }
    }
  })
}
